var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tour-button-wrap hide-for-print"},[_c('div',{staticClass:"tour-button",on:{"click":function($event){return _vm.$emit('clicked')}}},[_vm._v("i")]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.$store.state.showTourTooltip)?_c('div',{staticClass:"tour-button__help"},[_vm._v(_vm._s(_vm.$Strings('tour_tooltip')))]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cb0a515","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tour/tourButton.vue
// module id = 352
// module chunks = 0